export enum GeneratedImageStatus {
  FAILED = 'failed',
  DONE = 'done',
  IN_PROGRESS = 'in_progress',
  TIMED_OUT = 'timed_out',
}

export enum HandledGraphQLErrors {
  MAX_PROJECTS = 'Maximum allowed projects reached',
}

export enum OriginalImageStatus {
  FAILED = 'failed',
  DONE = 'done',
}

export enum OriginalImageStatusMap {
  Redacted = 'uploadPhotoSheet.uploadRedactedErrorMessage',
  'Too small' = 'uploadPhotoSheet.uploadTooSmallErrorMessage',
  'Too narrow' = 'uploadPhotoSheet.uploadTooNarrowErrorMessage',
  'Too wide' = 'uploadPhotoSheet.uploadTooWideErrorMessage',
  'No status' = 'uploadPhotoSheet.uploadNoStatusErrorMessage',
  'default' = 'uploadPhotoSheet.uploadRedactedErrorMessage',
}

export enum CreatedFrom {
  FAVORITE = 'favorite',
  ORIGINAL = 'original',
  STYLE = 'style',
  PROJECT = 'project',
  MATERIAL_CALLOUT = 'material_callout',
}

export const ALL_STYLES = 'All styles';
export const MY_UPLOAD_STYLE = 'My upload';

export const FINAL_GENERATED_IMAGE_STATUSES: string[] = [
  GeneratedImageStatus.FAILED,
  GeneratedImageStatus.DONE,
  GeneratedImageStatus.TIMED_OUT,
];
